import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";

export default function PaymentCancel() {
  const { setOpen } = useCart();
  return (
    <div className="max-w-xl mx-auto px-4 py-28 text-center rise">
      <h1 data-testid="payment-cancel-title" className="font-display font-black uppercase text-5xl">Checkout cancelled</h1>
      <p className="text-neutral-400 mt-3">No worries — your cart is saved.</p>
      <div className="flex gap-3 justify-center mt-10">
        <button onClick={() => setOpen(true)} data-testid="reopen-cart-button" className="h-12 px-6 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-display uppercase font-black tracking-wider">Back to cart</button>
        <Link to="/shop" className="h-12 px-6 border border-white/20 hover:bg-white hover:text-black font-display uppercase font-bold tracking-wider grid place-items-center">Shop</Link>
      </div>
    </div>
  );
}
